(function() {
    'use strict';
    angular.module('Services').factory('ComplianceTriggerTable', ComplianceTriggerTable);
    ComplianceTriggerTable.$inject = [
        '$location',
        'ComplianceService',
        'TableLiteFactory',
        'toastr',
        '$uibModal'
    ];

    function ComplianceTriggerTable(
        $location,
        ComplianceService,
        TableLiteFactory,
        toastr,
        $uibModal
    ) {
        return function (compliance) {
            function openTriggerTable(trigger) {
                $uibModal.open({
                    animation: true,
                    ariaLabelledBy: 'modal-title',
                    ariaDescribedBy: 'modal-body',
                    controller: 'TriggerModalController',
                    templateUrl: '/templates/pages/compliance/modals/TriggerModal.html',
                    backdrop: 'static',
                    controllerAs: 'vm',
                    size: 'md',
                    appendTo: $('body'),
                    resolve: {
                        trigger: () => trigger,
                        compliance: () => compliance,
                        tableData: () => tableData.data
                    }
                }).result.then((compliance)=>{
                    sendRequest({});
                });
            }
            const tableData = {
                /*tableName: 'ComplianceTriggerTable',*/
                optionAddOns: {
                    buttons: [{
                        class: 'btn-primary',
                        label: 'Add new',
                        tooltip: 'Add new compliance rule',
                        onClick: function(){
                            openTriggerTable({});
                        }
                    }]
                },
                config: {
                    noPagination: false,
                    noHeaders: false,
                    noItemsView: false,
                    noTableFooter: false,
                    tableMinHeight: '10em'
                },
                headers: [{
                    label: 'Compliance Reminder',
                    viewName: 'name',
                    filterName: 'complianceReminder.name',
                    filter: {
                        type: 'text',
                        placeholder: 'Search',
                        onSubmit: function(header) {
                            sendRequest(evaluateFilter(header));
                        }
                    },
                    headerFn: function() {
                        sort(this.filterName);
                    }
                }, {
                    label: 'Event',
                    viewName: 'event',
                    filterName: 'triggerEvent',
                    filter: {
                        type: 'text',
                        placeholder: 'Search',
                        onSubmit: function(header) {
                            sendRequest(evaluateFilter(header));
                        },
                        model: '' //optional
                        //text and inputDropdown uses `model` attribute for ng-model
                    },
                    headerFn: function() {
                        sort(this.filterName);
                    }
                }, {
                    label: 'Next Run',
                    viewName: 'nextRun',
                    filterName: 'nextRun',
                    headerFn: function() {
                        sort(this.filterName);
                    }
                }, {
                    label: 'Last Run',
                    viewName: 'lastRun',
                    filterName: 'lastRun',
                    headerFn: function() {
                        sort(this.filterName);
                    }
                }, {
                    label: 'Actions',
                    viewName: 'action',
                    class: 'text-center',
                    /*filter: {
                        type: 'button',
                        buttons: [
                            {
                                class: 'btn-danger btn',
                                label: 'Delete selected',
                                onClick: () => {
                                    toastr.info('This feature is not yet available');
                                }
                            }
                        ]
                    }*/
                }],
                rowOnClick: trigger=>openTriggerTable(trigger),
                data: []
            };
            const tableActions = new TableLiteFactory(tableData,
                {
                    serviceCallback: ComplianceService.triggers.getAll,
                    callbackFormat: ['success','error','filter'],
                    postRequestCallback: data => {
                        buildTableData(data);
                    },
                    postRequestErrorCallback: err => {
                        buildTableData(null);
                        toastr.error(err);
                    },
                    defaultFilters : {
                        size: 20,
                        page: 0,
                        sort: 'id,desc',
                        'complianceItem.Id': compliance.id
                    }
                }
            );
            const sort = tableActions.sort;
            const evaluateFilter = tableActions.evaluateFilter;
            const sendRequest = tableActions.sendRequest;

            function deleteTrigger(row) {
                row.action.buttons[0].text = "Deleting...";
                ComplianceService.triggers.delete(data => {
                    toastr.success('Trigger deleted.');
                    sendRequest({});
                }, error => {
                    toastr.error('Unable to delete trigger', error.message);
                    sendRequest({});
                }, row.id);
            }

            function buildTableData(data) {
                /*** START - Building of Data ***/

                tableActions.initializeTableData(data);
                if(!data)
                    return null;
                angular.forEach(data.content, function(row, index) {
                    row.name = row.complianceReminder.name;
                    row.event = row.triggerEvent;
                    row.nextRun = row.nextRun || 'N/A';
                    row.lastRun = row.lastRun || 'N/A';

                    row.action = {
                        type: 'button',
                        buttons: [{
                            text: 'Delete',
                            class: 'btn btn-danger',
                            action: function () {
                                deleteTrigger(row);
                            }
                        }]
                    };
                    tableData.data.push(row);
                });
                /*** END - Building of Data ***/
            }
            this.tableData = tableData;
        }
    }
})();



// WEBPACK FOOTER //
// ./js/services/tables/compliance/ComplianceTriggerTable.js